import React from "react";
import styled from "styled-components";

const Container = styled.div`
  border: 3px solid #ff8f4e;
  border-radius: 10px;
  padding: 1.5rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ImageContainer = styled.div`
  width: 45px;
  height: 45px;
  display: none;
`;

const StyledList = styled.ul`
  list-style-type: disc;
`;

const IndiaAIFestivalMainAwards = ({ title, data }) => {
  return (
    <div className="w-100">
      <h2 className="text-center">{title}</h2>
      <Container>
        {data.categories.map((category, idx) => (
          <div key={idx} className="w-100 rounded-10 mb-4">
            <div className="d-flex mb-2">
              <div className="d-flex align-items-center w-100">
                <h5 className="text-blue flex-grow-1 mb-0 text-center">
                  {category.title}
                </h5>
                <ImageContainer>
                  <img src={category.imageUrl} className="w-100" alt="" />
                </ImageContainer>
              </div>
            </div>
            <StyledList className="pl-4">
              {category.items.map((item, index) => (
                <li key={index} className="mb-2">
                  {item.description}
                </li>
              ))}
            </StyledList>
          </div>
        ))}
      </Container>
    </div>
  );
};

export default IndiaAIFestivalMainAwards;
